/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BedPccMapping
 */
export interface BedPccMapping {
    /**
     * 
     * @type {string}
     * @memberof BedPccMapping
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof BedPccMapping
     */
    pcc_bed_id?: string;
}

/**
 * Check if a given object implements the BedPccMapping interface.
 */
export function instanceOfBedPccMapping(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function BedPccMappingFromJSON(json: any): BedPccMapping {
    return BedPccMappingFromJSONTyped(json, false);
}

export function BedPccMappingFromJSONTyped(json: any, ignoreDiscriminator: boolean): BedPccMapping {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'pcc_bed_id': !exists(json, 'pcc_bed_id') ? undefined : json['pcc_bed_id'],
    };
}

export function BedPccMappingToJSON(value?: BedPccMapping | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'pcc_bed_id': value.pcc_bed_id,
    };
}

